var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2 56C2 26.0712 26.0712 2 56 2C85.9288 2 110 26.0712 110 56C110 85.9288 85.9288 110 56 110C26.0712 110 2 85.9288 2 56Z",
    stroke: "#43B02A",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "checkmark",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8887 33.6271C86.9843 32.7221 85.5235 32.7221 84.6191 33.6271L39.9513 78.2915L25.3843 63.7238C24.48 62.8188 23.0122 62.8188 22.1078 63.7238C21.2035 64.6275 21.2035 66.0925 22.1078 66.9976L38.3165 83.2028C38.7687 83.6543 39.36 83.8804 39.9513 83.8804C40.5426 83.8804 41.1409 83.6543 41.593 83.2028L87.8887 36.9002C88.793 35.9958 88.793 34.5315 87.8887 33.6271Z",
    stroke: "#43B02A",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.7a6984861875d7b95c63e5d05345a904.svg";
export { ForwardRef as ReactComponent };